import { LicenceHolder, LicenceState } from '../Enums/licence-state.enum';
import { PriceComponentType } from '../Enums/price-component-type.enum';

export const LICENCE_COMPONENT_OPTIONS: readonly PriceComponentType[] = [
  PriceComponentType.SEAT,
  PriceComponentType.AGENT,
];

export const LICENCE_STATE_OPTIONS: readonly LicenceState[] = [
  LicenceState.ASSIGNED,
  LicenceState.FREE,
  LicenceState.ENDING,
  LicenceState.HALF_STATE,
];

export const LICENCE_HOLDER_OPTIONS: readonly LicenceHolder[] = [
  LicenceHolder.USER,
  LicenceHolder.DEVICE,
  LicenceHolder.NONE,
];

export const REASON_MAX = 500;

export const DELTA_MAX = 500;

export const QUANTITY_MAX = 500;

export const LICENCE_HELD_BY_KEY = 'backoffice.licences.held_by';

export const ADJUST_APPLIED_MESSAGE = 'backoffice.licences.adjust.done';

export const RESUME_APPLIED_MESSAGE = 'backoffice.licences.resume.done';

export const ASSIGN_APPLIED_MESSAGE = 'backoffice.licences.assign.done';

export const RELEASE_APPLIED_MESSAGE = 'backoffice.licences.release.done';

export const LICENCE_CANCELLED_MESSAGE = 'backoffice.licences.cancel.done';

export const LICENCE_RESUMED_MESSAGE = 'backoffice.licences.resume_one.done';

export const RELEASE_CONFIRM_TITLE = 'backoffice.licences.release.title';

export const RELEASE_CONSEQUENCE = 'backoffice.licences.release.consequence';

export const RELEASE_CONFIRM_LABEL = 'backoffice.licences.release.confirm';

export const LICENCE_CANCEL_CONFIRM_TITLE = 'backoffice.licences.cancel.title';

export const LICENCE_CANCEL_CONSEQUENCE = 'backoffice.licences.cancel.consequence';

export const LICENCE_CANCEL_CONFIRM_LABEL = 'backoffice.licences.cancel.confirm';

export const LICENCE_RESUME_CONFIRM_TITLE = 'backoffice.licences.resume_one.title';

export const LICENCE_RESUME_CONSEQUENCE = 'backoffice.licences.resume_one.consequence';

export const LICENCE_RESUME_CONFIRM_LABEL = 'backoffice.licences.resume_one.confirm';

export const LICENCE_SUBJECT_KEY = 'backoffice.licences.assign.subject';
